import { DOCUMENT, inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class WakeLockService {
    private readonly document = inject(DOCUMENT);

    private wakeLock: WakeLockSentinel | null = null;
    private releasedByVisibilitychange = false;

    constructor() {
        this.document.addEventListener('visibilitychange', async () => {
            if (this.wakeLock || this.releasedByVisibilitychange) {
                if (this.document.visibilityState === 'hidden') {
                    this.release(true);
                } else {
                    this.request();
                }
            }
        });
    }

    release(releasedByVisibilitychange = false): void {
        if (this.wakeLock) {
            this.wakeLock.release();
            this.wakeLock = null;
            this.releasedByVisibilitychange = releasedByVisibilitychange;
            console.log(
                `Wake Lock released${releasedByVisibilitychange ? ' by visibilitychange' : ''}`,
            );
        }
    }

    async request(): Promise<void> {
        if ('wakeLock' in navigator) {
            try {
                this.wakeLock = await navigator.wakeLock.request('screen');
                this.releasedByVisibilitychange = false;
                console.log('Wake Lock acquired');
            } catch (err) {
                console.warn("Can't acquire wake Lock", err);
            }
        } else {
            console.warn('Wake lock API is not supported by this browser.');
        }
    }
}
